export default {
  methods: {
    getShipmentDetailUrl(transportStep) {
      return `https://dweb.pro/t=${transportStep.missionTrackId}`;
    },
  },
};
